import type { OnboardingStatus as OnboardingStatusValue } from '../../types/definitions/vendor/graphql-schema.d';

export const OnboardingStatus = {
  FULLY_ONBOARDED: 'FULLY_ONBOARDED',
  NOT_YET_ONBOARDED: 'NOT_YET_ONBOARDED',
  ONBOARDING_FAILED: 'ONBOARDING_FAILED',
  PENDING: 'PENDING',
} as const satisfies {
  [Status in OnboardingStatusValue]: Status;
};
